import React, { createContext, FC } from 'react'
import { useLocalStorage } from 'react-use'

import { defaultSettings } from '../../config'
import type { SettingsContextProps } from './types'
import { SettingsValueProps } from './types'

const initialState: SettingsContextProps = {
  ...defaultSettings,
  onToggleMode: () => undefined,
  onResetSetting: () => undefined,
}

const SettingsContext = createContext(initialState)

const SettingsProvider: FC = ({ children }) => {
  const [settings, setSettings] = useLocalStorage<SettingsValueProps>('settings', {
    themeMode: initialState.themeMode,
  })

  const onToggleMode = () => {
    setSettings({
      ...settings,
      themeMode: settings?.themeMode === 'light' ? 'dark' : 'light',
    })
  }

  const onResetSetting = () => {
    setSettings({
      themeMode: initialState.themeMode,
    })
  }

  return (
    <SettingsContext.Provider
      value={{
        ...(settings || defaultSettings),
        onToggleMode,
        onResetSetting,
      }}
    >
      {children}
    </SettingsContext.Provider>
  )
}

export { SettingsProvider, SettingsContext }
